export enum PurchaseType {
  OTP = 'otp',
  SUB = 'sub',
}
